import api from "./axios";

/* ===== MANUAL HOLIDAYS ===== */
export const getHolidays = () => api.get("/holidays/");
export const createHoliday = (data) => api.post("/holidays/", data);
export const deleteHoliday = (id) => api.delete(`/holidays/${id}/`);

/* ===== HOLIDAY CALENDAR ===== */
export const getHolidayCalendar = () =>
  api.get("/holidays/calendar/");

export const uploadHolidayCalendar = (formData) =>
  api.post("/holidays/calendar/", formData);

/* ===== COMP OFF ===== */
export const getCompOffData = () =>
  api.get("/leaves/admin/comp-off/");

export const grantCompOff = (data) =>
  api.post("/leaves/admin/comp-off/grant/", data);

export const deleteCompOffGrant = (id) =>
  api.delete(`/leaves/admin/comp-off/${id}/delete/`);

export const getEmployeeCompOffs = () =>
  api.get("/leaves/my-comp-offs/");
